/*
 * @Author: zhangxiaofeng
 * @Date: 2020-04-09
 * @LastEditors: zhangxiaofeng
 * @LastEditTime: 2020-04-09
 * @Description: file content
 */
/**
 * @Description: 路由配置
 * @Date: 2020-04-09
 * @Modify:
 * @Author: zhangxiaofeng
 */
import Layout from '@/components/layout/Index.vue'

export default [
  {
    path: '/board',
    component: Layout,
    children: [
      {
        path: 'gtj',
        component: () => import('@/views/board/children/gtj'),
        meta: { title: '造价云管理平台', icon: 'home', noCache: true, keepAlive: false, auth: true }
      },
      {
        path: 'no_permission',
        component: () => import('@/components/common/NoAuthPage/Index.vue'),
        meta: { title: '企业数据库-无权限', icon: 'home', noCache: true, keepAlive: false, auth: true }
      }
    ]
  }
]
